const $ = require('jquery');
global.$ = global.jQuery = $;
require('../../../vendor/twbs/bootstrap/dist/js/bootstrap.min.js');
//require('../../../Resources/OneBidSiteBundle/public/js/masonry.pkgd.min.js');

